import { render, staticRenderFns } from "./advances.vue?vue&type=template&id=1f25b2c2&scoped=true"
import script from "./advances.vue?vue&type=script&lang=js"
export * from "./advances.vue?vue&type=script&lang=js"
import style0 from "./advances.vue?vue&type=style&index=0&id=1f25b2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25b2c2",
  null
  
)

export default component.exports